import { inject } from '@angular/core'
import { CanActivateFn, GuardResult, Router } from '@angular/router'
import { map, Observable, of, switchMap } from 'rxjs'
import { AppRoute } from '../app.routes.fixtures'
import { AuthService } from '../services/auth/auth.service'

const debug = false
/**
 *  Skip intro page, if a user is already logged in.
 */
export const IntroGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.getAuthResult().pipe(
    switchMap((authResult): Observable<GuardResult> => {
      if (authService.isLoggedIn() && authResult?.access_token) {
        if (debug) {
          console.log('[IntroGuard] user is logged in; route to home')
        }
        return of(router.createUrlTree([`/${AppRoute.home}`]))
      }
      if (authResult?.refresh_token) {
        return authService.refreshSession().pipe(
          map((isAuthenticated) => {
            if (debug) {
              console.log('[IntroGuard] Refreshed token: ' + isAuthenticated)
            }
            if (isAuthenticated) {
              return router.createUrlTree([`/${AppRoute.home}`])
            } else {
              return true
            }
          })
        )
      }

      if (debug) {
        console.log('[IntroGuard] user is not logged in')
      }
      return of(true)
    })
  )
}
